import { render, staticRenderFns } from "./ComponentAlertConfigDialog.vue?vue&type=template&id=4e67c0b8"
import script from "./ComponentAlertConfigDialog.vue?vue&type=script&lang=js"
export * from "./ComponentAlertConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports